import React, { useState } from 'react';
import { ReactNestedMenu } from 'react-nested-menu';
import { _ as _slicedToArray } from './_rollupPluginBabelHelpers-76ab84fa.js';
import { Link, navigate } from 'gatsby';
import Dropdown from '@accrosoft-ltd/accro-multi-level-dropdown';

var NestedNavSingleLevel = function NestedNavSingleLevel(_ref) {
  var item = _ref.item;
  item.id;
  var parentSlug = item.parentSlug,
      slug = item.slug,
      title = item.title,
      parentId = item.parentId;
  return /*#__PURE__*/React.createElement("div", {
    className: "nested-menu-link-wrap"
  }, /*#__PURE__*/React.createElement(Link, {
    to: parentSlug && parentSlug !== '/' ? parentSlug + slug : slug,
    className: "nested-menu-link-link ".concat(parentId ? "childLink" : "parentLink")
  }, /*#__PURE__*/React.createElement("span", null, title)));
};

var NestedNavMultiLevel = function NestedNavMultiLevel(_ref2) {
  var item = _ref2.item;
  item.id;
  var parentSlug = item.parentSlug,
      slug = item.slug,
      title = item.title,
      parentId = item.parentId;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var handleClick = function handleClick() {
    setOpen(function (prev) {
      return !prev;
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "nested-menu-link-wrap ".concat(open ? "active" : "inactive")
  }, /*#__PURE__*/React.createElement(Link, {
    to: parentSlug && parentSlug !== '/' ? parentSlug + slug : slug,
    className: "nested-menu-link-link ".concat(parentId ? "childLink" : "parentLink", " ").concat(open ? "active" : "inactive")
  }, /*#__PURE__*/React.createElement("span", null, title)), /*#__PURE__*/React.createElement("div", {
    className: "nav-child-drop-trigger",
    onClick: function onClick() {
      return handleClick();
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(open ? "active fas fa-angle-up" : "inactive fas fa-angle-down")
  })));
};

var linkTransformer = function linkTransformer(menuItem) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, menuItem.children ? /*#__PURE__*/React.createElement(NestedNavMultiLevel, {
    item: menuItem
  }) : /*#__PURE__*/React.createElement(NestedNavSingleLevel, {
    item: menuItem
  }));
};

var RenderChildLinkHTML = function RenderChildLinkHTML(_ref) {
  var child = _ref.child,
      i = _ref.i;
  return /*#__PURE__*/React.createElement(Dropdown.Item, {
    className: "dropdown-item link",
    key: i
  }, child.children && /*#__PURE__*/React.createElement("span", {
    className: "fas fa-angle-right"
  }), /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      navigate(child.parentSlug && child.parentSlug !== '/' ? child.parentSlug + child.slug : child.slug);
    }
  }, /*#__PURE__*/React.createElement("span", null, child.title)), child.children && child.children.length > 0 && /*#__PURE__*/React.createElement(Dropdown.Submenu, {
    menuClassName: "dropdown-submenu",
    className: "dropdown-submenu"
  }, child.children.map(function (childtwo, itwo) {
    return /*#__PURE__*/React.createElement(RenderChildLinkHTML, {
      child: childtwo,
      key: itwo
    });
  })));
};

var RenderChildLinks = function RenderChildLinks(_ref2) {
  var item = _ref2.item;
  return /*#__PURE__*/React.createElement(React.Fragment, null, item.children && item.children.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, item.children.map(function (child, i) {
    return /*#__PURE__*/React.createElement(RenderChildLinkHTML, {
      key: i,
      child: child
    });
  })));
};

var ReturnChildNavItems = function ReturnChildNavItems(_ref3) {
  var WebsiteNavData = _ref3.WebsiteNavData;
  return /*#__PURE__*/React.createElement(React.Fragment, null, WebsiteNavData && WebsiteNavData.length > 0 ? WebsiteNavData.map(function (item, i) {
    return /*#__PURE__*/React.createElement(Dropdown, {
      key: i,
      menuClassName: "dropdown-child-nav",
      wrapperClassName: "dropdown-wrapper-nav",
      buttonClassName: "dropdown-parentLink",
      className: "dropdown-child-nav",
      isActive: true,
      title: item.title,
      onClick: function onClick() {
        return navigate(item.parentSlug && item.parentSlug !== '/' ? item.parentSlug + item.slug : item.slug);
      }
    }, /*#__PURE__*/React.createElement(RenderChildLinks, {
      item: item,
      i: i
    }));
  }) : /*#__PURE__*/React.createElement("li", {
    className: "loading-nav"
  }));
};

var HeaderMenuBarNested = function HeaderMenuBarNested(props) {
  var Html = props.html || /*#__PURE__*/React.createElement("div", {
    className: "HeaderMenuBarNested"
  }, props.isMobile ? /*#__PURE__*/React.createElement(ReactNestedMenu, {
    menuData: props.websiteNavData || [],
    navParentClassname: "dropdown vertical menu nested",
    navTopLevelParentClassname: "navigation vertical menu",
    navChildClassname: "headerLink child",
    linkTransformer: linkTransformer
  }) : /*#__PURE__*/React.createElement(ReturnChildNavItems, {
    WebsiteNavData: props.websiteNavData || []
  }));
  return Html;
};

export default HeaderMenuBarNested;